import { Grid } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import Text from "../../atoms/Text/Text";

const AdvantagesContainer = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const promo_code = searchParams.get("promo_code");

  return (
    <Grid container spacing={2} className="AdvantagesContainer">
      <Grid item xs={6}>
        <Text>
          <Trans
            i18nKey={"santevet:ADVANTAGE.FIRST"}
            components={{ span: <span /> }}
          />
        </Text>
      </Grid>
      <Grid item xs={6}>
        <Text>
          <Trans
            i18nKey={"santevet:ADVANTAGE.SECOND"}
            components={{ span: <span /> }}
          />
        </Text>
      </Grid>
      {promo_code && (
        <Grid item xs={12} className="promoCode">
          <Text className="alignCode">
            {`${t("santevet:ADVANTAGE.PROMO_CODE")}`} <span>{promo_code}</span>
          </Text>
        </Grid>
      )}
    </Grid>
  );
};

export default AdvantagesContainer;
